const RemoveActionType = Object.freeze({
  Delete: 1,
  UnSubscribe: 2,
  ReSubscribe: 3,
  Block: 4,
  UnBlock: 5,
});
export default RemoveActionType;
